module.exports = __webpack_public_path__ + "static/media/CheckTickGrey.34ebe2bb.svg";